import { render, staticRenderFns } from "./AppRolesCreate.vue?vue&type=template&id=150ea648&scoped=true&"
import script from "./AppRolesCreate.vue?vue&type=script&lang=js&"
export * from "./AppRolesCreate.vue?vue&type=script&lang=js&"
import style0 from "./AppRolesCreate.vue?vue&type=style&index=0&id=150ea648&prod&lang=scss&scoped=true&"
import style1 from "./AppRolesCreate.vue?vue&type=style&index=1&id=150ea648&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ea648",
  null
  
)

export default component.exports